module.exports = {
  CONTENT: {
    SUBHEADER: {
      city: 'Cachoeiro de Itapemirim',
    },
    HEADER: {
      title: 'Bem vindo ao agendamento de serviços',
      titleLogged: 'Olá, ',
      subtitle:
        'Agende um atendimento na Prefeitura de Cachoeiro de Itapemirim. Escolha o serviço, siga as instruções e leia com atenção as informação para a confirmação.',
    },
    STEPPER: {
      ONE: {
        title: 'Categoria',
        description: 'Selecione a categoria na qual deseja marcar um serviço',
      },
      TWO: {
        title: 'Serviços',
        description: 'Selecione o serviço e os detalhes do atendimento',
      },
      THREE: {
        title: 'Insira os dados',
        description: 'Insira os dados necessários para prosseguir',
      },
      FOUR: {
        title: 'Dados do agendamento',
        description: 'Escolha a data e o horário desejados.',
      },
      FIVE: {
        title: 'Confirmação',
        description: 'Confira seus dados e confirme o seu atendimento',
      },
    },
    HOME: {
      BANNER: {
        description:
          'Todos os agendamentos da sua cidade em um único lugar de forma intuitiva, rápida e fácil. Faça seu cadastro para agendar um serviço na Prefeitura de Cachoeiro de Itapemirim.',
      },
      INFOCARDS: {
        FIRST: {
          title: 'Mantenha seu cadastro sempre atualizado',
          description:
            'É muito importante. Assim, você pode garantir o acesso ao agendamento online e realizar o acompanhamento.',
          buttonLabel: 'Atualizar dados',
        },
        SECOND: {
          title: 'Dúvidas sobre o sistema?',
          description:
            'Clique no link abaixo e confira algumas dicas e soluções que separamos para te auxiliar.',
          buttonLabel: 'Preciso de ajuda',
        },
        THIRD: {
          title: 'Avalie o portal e envie sugestões',
          description: 'Queremos te ouvir para desenvolvermos ainda mais nosso sistema. Participe!',
          buttonLabel: 'Avalie',
        },
      },
    },
    FOOTER: {
      MENU: {
        myAppointments: 'Meus agendamentos',
        appointment: 'Agendar',
        faq: 'Dúvidas',
        account: 'Minha conta',
        shortcut: 'Atalhos de teclado',
      },
      CONTACT: {
        title: 'Em caso de dúvidas:',
        tel: '(28) 98814-3357',
        telLabel: 'Segunda à sexta, de 07:00 às 17:00',
      },
      SOCIAL: {
        facebook: 'https://www.facebook.com/prefcachoeiro/',
        linkedin:
          'https://www.linkedin.com/company/prefeitura-municipal-de-cachoeiro-de-itapemirim/',
        instagram: 'https://www.instagram.com/prefcachoeiro/',
        youtube: 'https://www.youtube.com/user/semcoscachoeiro',
      },
    },
    OTHERS: {
      APP: {
        googlePlay: 'https://prml.me/JIVY',
        appleStore: 'https://prml.me/JJs7',
        title: 'Aplicativo Cachoeiro de Itapemirim On',
        text: 'Baixe o app para interagir ainda mais com a prefeitura de Cachoeiro de Itapemirim. Informações, orientações e serviços em um único lugar de forma intuitiva, rápida e fácil.',
      },
    },
    FAQ: {
      faqItems: [
        {
          id: 0,
          question: 'Posso agendar para outras pessoas no meu cadastro?',
          answer:
            'Sim! Após escolher a data e hora do serviço, selecione a opção "Para outra pessoa", insira os dados e confirme.',
        },
        {
          id: 1,
          question: 'Posso cancelar um agendamento?',
          answer:
            'Sim! Na tela inicial, clique em ‘consultar/cancelar agendamento’, acesse o agendamento que deseja cancelar e clique no botão vermelho ‘cancelar’. Pronto!',
        },
        {
          id: 2,
          question: 'Fiz o cadastro mas não recebi o e-mail. E agora?',
          answer:
            'Caso isso aconteça, existe algumas formas de resolver, são elas:\n\n1. Cheque sua caixa de spam.\n2. Tente realizar o login digitando seu e-mail e senha cadastrados. Será exibida uma tela para validação, clique em reenviar o e-mail, aguarde uns instantes e verifique o recebimento.\n3. Espere alguns minutos, em horário de pico pode demorar mais do que o desejado.\n4. Selecione ‘recuperar senha’ para que um novo e-mail seja enviado.',
        },
        {
          id: 3,
          question: 'Cadastrei meu e-mail errado. O que eu faço?',
          answer:
            'Entre em contato com o nosso suporte pelo e-mail ouvidoria@cachoeiro.es.gov.br para ser orientado adequadamente.',
        },
      ],
    },
    POLICY: {
      text: 'Esta página do site da Prefeitura de Cachoeiro de Itapemirim usa Cookies Operacionais de Sessão para o funcionamento do sistema, que podem armazenar seus dados pessoais indiretamente. Conforme detalhado no AVISO DE PRIVACIDADE e de acordo com o Art. 5 da LGPD (Lei 13.709/2018) solicitamos seu CONSENTIMENTO para prosseguir. Sua rejeição pode implicar no não funcionamento das tecnologias do site. Você aceita os Cookies de Sessão?',
      ref: 'https://upcities.app/politica-privacidade-cachoeiro-itapemirim',
    },
  },
};
